import { SecurityStatus } from '../api/octopus';
import { EntityEvent } from './entity';
import { InteractionEvent } from './interaction';
import { RelatedEntry } from './related-entry';

export interface ActivityTimeline extends EntityEvent {
  subject?: string;
  source?: string;
  regarding?: RelatedEntry;
  description?: string;
  descriptionRichText?: string;
  date: { value: string; display: string };
  private?: boolean;
  secStatus?: SecurityStatus;
  creator: { value: string; display: string };
  withs?: RelatedEntry[];
  users?: RelatedEntry[];
  isRichText?: boolean;
  category?: string;
}

export interface ActivityInteractionTimelineEvent
  extends ActivityTimeline,
    InteractionEvent {}

export enum ActivityTimelineColumnField {
  StartDate = 'startDate',
  Type = 'type',
  Regarding = 'with',
  InteractionCategory = 'interactionCategory',
}
